// extracted by mini-css-extract-plugin
export default {"container":"container___Nkzf_","starCount":"starCount___cTDZO","firstColumn":"firstColumn___aSHGC"};